export enum SocialIconName {
    FaceBook = 'facebook',
    Instagram = 'instagram',
    Pinterest = 'pinterest',
    Youtube = 'youtube',
}
